import { ButtonBase, IEvent, delayedCall, dispatcher, killDelayedCall, ingenuity } from "@quest/base-core";
import { GameIntroController, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { eventDispatchers } from "../Constants/EventDispatchers";
export class GameIntroControllerGame extends GameIntroController {

    //Method overrided to fire event to show bottom bar logo
    protected onContinuePressUp(evt: IEvent): void {
        // (ingenuity.soundManager as any).playSound (SoundConstant.COMMON_CLICK_SOUND, 1, false, "soundList");
        super.onContinuePressUp(evt);
        dispatcher.fireEvent(eventDispatchers.SHOW_TOP_BAR);
        if (!ingenuity.deviceEnv.isDesktop && (ingenuity.deviceEnv.getIsIpad() || ingenuity.deviceEnv.getDeviceOS() !== 'ios')) {
            dispatcher.fireEvent(eventDispatchers.FULL_SCREEN_GAME);
        }
    }

    /**to handle top and bottom bar visibility behind loading screen */
    protected subscribeEvents(): void {
        dispatcher.on(SlotEventConstantsBehavior.SHOW_GAME_INTRO_VIEW, this.view.showView, this.view);
        dispatcher.on(SlotEventConstantsBehavior.LAUNCH_GAME_INTRO, this.launchGameIntro, this);
    }

    // Overrided to remove top & bottom bar elements
    protected initializeElements(): void {
        this.continueBtnContainer = this.view.getContainerByID("continueButtonContainer");
        this.continueGameIntro = this.view.getButtonById(SlotConstantsBehavior.gameIntroContinueBtn) as ButtonBase;
        this.continueBtnAnimation = this.view.getAnimationById("gameIntroBtnAnimation");
    }

    // Overrided to show intro with delay
    protected launchGameIntro(): void {
        const showGameIntroDelayTime: number = 2100;
        const delayKey: string = "buttonListener";
        delayedCall(
            delayKey,
            showGameIntroDelayTime,
            () => {
                killDelayedCall(delayKey);
                super.launchGameIntro();
                this.bindContinueButton();
            },
            this
        );
        this.handleToolBarPopUp();
    }
    private handleToolBarPopUp(): void {
        if (!ingenuity.deviceEnv.isDesktop && !ingenuity.deviceEnv.getIsIpad() && ingenuity.deviceEnv.getDeviceOS() === 'ios') {
            const devicePopUpGif = document.getElementById("fs-overlay");
            devicePopUpGif.style.display = "block";
            window.addEventListener(
                "touchstart", (e) => {
                    devicePopUpGif.style.display = "none";
                }
            );
        }
    }

    // overrided to show top and bottom bar with delay.
    private bindContinueButton(): void {

        this.continueGameIntro && this.continueGameIntro.on(ButtonBase.UP, this.onContinuePressUp, this);
    }
}


